module.exports = __webpack_public_path__ + "static/media/obx_black.e722aca5.png";